import React from 'react';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import classNames from 'classnames';
import { round, debounce } from 'lodash';
import SkillCourseTile from './SkillCourseTile';
import chevron from '../../../../ASUPhotos/icons/carouselChevron.svg';

export class SkillDropDown extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.carouselRow = React.createRef();
    this.state = {
      index: 1,
      scrollWidth: 0,
      scrollLeft: 0,
    };
  }

  TILE_WIDTH = 160;

  TILE_MARGIN = 5;

  totalIncrement = () => {
    return this.TILE_MARGIN + this.TILE_WIDTH;
  };

  displaySkillCourseTiles = () => {
    return this.props.courses.map((course) => {
      return (
        <SkillCourseTile
          key={course.upskilling_offering}
          type={course.offering_type}
          photoUrl={course.photo_url}
          upskillOffering={course.upskilling_offering}
          offeringUrl={course.url}
          tileWidth={this.TILE_WIDTH}
          tileMargin={this.TILE_MARGIN}
          description={course.description}
        />
      );
    });
  };

  updateScrollWidth = () => {
    return (
      this.carouselRow.current &&
      this.setState({
        scrollWidth:
          this.carouselRow.current.scrollWidth -
          this.carouselRow.current.offsetWidth,
      })
    );
  };

  componentDidMount = () => {
    window.addEventListener('resize', this.debounceUpdateScrollWidth);
    this.updateScrollWidth();
  };

  debounceUpdateScrollWidth = debounce(this.updateScrollWidth, 500);

  debounceUpdateScrollPosition = debounce(
    () => this.updateScrollPosition(),
    250
  );

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.debounceUpdateScrollWidth);
  };

  scrollCarousel = (num) => {
    const { index } = this.state;
    const newIndex = index + num;
    const currentPos = this.carouselRow.current.scrollLeft;
    const rounded = round(currentPos / this.totalIncrement());
    const leftScroll =
      this.totalIncrement() * rounded + this.totalIncrement() * num;
    this.carouselRow.current.scrollTo({
      top: 0,
      left: leftScroll,
      behavior: 'smooth',
    });
    this.setState({
      index: newIndex,
    });
  };

  updateScrollPosition = () => {
    this.setState({
      scrollLeft: this.carouselRow.current.scrollLeft,
    });
  };

  disablePrev = () => {
    if (!this.carouselRow || !this.carouselRow.current) return false;
    return this.carouselRow.current.leftScroll <= 0;
  };

  render() {
    const { scrollLeft, scrollWidth } = this.state;
    return (
      <Translation>
        {(t) => (
          <div id="skill-dropdown" className="skill-dropdown">
            <p
              className={classNames({
                'skill-dropdown__description': true,
                description_only: !this.props.tenant.features.includes(
                  'skills_course_recommendations'
                ),
              })}
            >
              {this.props.description}
            </p>
            {this.props.tenant.features.includes(
              'skills_course_recommendations'
            ) && (
              <>
                <span className="skill-dropdown__header">
                  {t('Improve your {{skillType}} skills today', {
                    skillType: this.props.skillTitle.toLowerCase(),
                    interpolation: { escapeValue: false },
                  })}
                </span>
                <div
                  className={classNames({
                    'skill-dropdown__carousel-row': true,
                    [this.props.carouselClassName]:
                      this.props.carouselClassName,
                  })}
                  ref={this.carouselRow}
                  onScroll={this.debounceUpdateScrollPosition}
                >
                  {this.displaySkillCourseTiles(this.props.courses)}
                </div>
                <div
                  className={classNames({
                    'skill-dropdown__carousel-buttons': true,
                    [this.props.carouselClassName]:
                      this.props.carouselClassName,
                  })}
                >
                  <div
                    role="button"
                    tabIndex={0}
                    style={{
                      visibility: scrollLeft <= 0 ? 'hidden' : 'visible',
                    }}
                    onClick={() => {
                      this.scrollCarousel(-1);
                    }}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key)) this.scrollCarousel(-1);
                    }}
                  >
                    <img
                      src={chevron}
                      alt="Previous slide"
                      className="skill-dropdown__rotate-180"
                    />
                  </div>
                  <div
                    role="button"
                    tabIndex={0}
                    style={{
                      visibility:
                        scrollLeft >= scrollWidth ? 'hidden' : 'visible',
                    }}
                    onClick={() => {
                      this.scrollCarousel(1);
                    }}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key)) this.scrollCarousel(1);
                    }}
                  >
                    <img src={chevron} alt="Next slide" />
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = state.tenant;
  return { tenant };
};

export default connect(mapStateToProps)(SkillDropDown);
